import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { copyToClipboard } from './paymentFormUtils';

interface CopyLinkRowProps {
  label?: string;
  link: string;
  helperText?: string;
  compact?: boolean;
}

const CopyLinkRow: React.FC<CopyLinkRowProps> = ({ label, link, helperText, compact }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!link) return;
    await copyToClipboard(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box
      sx={{
        p: compact ? 1.5 : 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'grey.50',
      }}
    >
      {label ? (
        <Typography variant="subtitle2" fontWeight={600} gutterBottom={!compact}>
          {label}
        </Typography>
      ) : null}
      {helperText && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
          {helperText}
        </Typography>
      )}
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'stretch', flexWrap: 'wrap' }}>
        <TextField
          fullWidth
          size="small"
          value={link || 'Salve o evento para gerar o link'}
          InputProps={{
            readOnly: true,
            sx: {
              fontFamily: 'monospace',
              fontSize: '0.8125rem',
              bgcolor: 'background.paper',
            },
          }}
          onClick={(e) => (e.target as HTMLInputElement).select()}
          sx={{ minWidth: 0, flex: '1 1 220px' }}
        />
        <Button
          size="small"
          variant={copied ? 'contained' : 'outlined'}
          color={copied ? 'success' : 'primary'}
          startIcon={!copied ? <ContentCopyIcon /> : undefined}
          onClick={handleCopy}
          disabled={!link}
          sx={{ flexShrink: 0, minWidth: 96 }}
        >
          {copied ? 'Copiado!' : 'Copiar'}
        </Button>
      </Box>
    </Box>
  );
};

export default CopyLinkRow;
